<template>
    <div class="view view--users">
        <data-table
            class="has-margin-b45"
            v-bind:data="tableData"
            v-on:sort="sortDataTable"
        ></data-table>

        <modal
            class="is-narrow"
            v-bind:title="__('Edit user')"
            v-bind:is-open="isOpenEditModal"
            v-on:close-modal="isOpenEditModal = false"
            v-bind:slot-props="errors"
        >
            <template v-slot:body>
                <div>
                    <div class="has-margin-b30">
                        <control
                            name="referralIdEditControl"
                            type="text"
                            v-bind:label="__('Referral ID')"
                            v-model="editedUser.referralId"
                        />
                        <div
                            class="has-text-danger has-margin-b10"
                            v-if="errors.referral_id != null"
                        >
                            {{ errors.referral_id[0] }}
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <btn
                    class="is-block is-success"
                    type="default"
                    v-html="__('Save')"
                    v-on:click="updateUser"
                ></btn>
            </template>
        </modal>
    </div>
</template>

<script>
import { Btn, Control, DataTable, Modal } from '@teamfurther/cinderblock';
import UserRepository from '../../repositories/UserRepository';
import ErrorMessageService from '../../services/ErrorMessageService';
import PriceService from '../../services/PriceService';
import store from '../../store';
import MessageHandler from '../../messageHandler';

export default {
    components: {
        Btn,
        Control,
        DataTable,
        Modal
    },
    created: function() {
        this.userRepository = new UserRepository();
        this.errorMessageService = new ErrorMessageService();
    },
    data: function() {
        return {
            editedUser: {
                id: null,
                email: '',
                name: '',
                password: '',
                passwordConfirmation: '',
                role: null,
                roleName: '',
                referralId: ''
            },
            errors: {},
            isOpenAddModal: false,
            isOpenDeleteModal: false,
            isOpenEditModal: false,
            tableData: {
                columnNames: {
                    name: this.__('Name'),
                    referralId: this.__('Referral ID'),
                    roleName: this.__('Role'),
                    invitedUsersCount: this.__('Sign ups by referral ID'),
                    totalAmountCollected: this.__('Total amount collected'),
                    isCelebrity: this.__('Is celebrity')
                },
                items: [],
                sortableColumns: ['name', 'roleName', 'isCelebrity']
            },
            users: [],
            userRepository: null,
            errorMessageService: null,
            priceService: new PriceService()
        };
    },
    methods: {
        getUsers: async function(sort = '') {
            try {
                const users = await this.userRepository.getUsers(sort);

                this.users = users.filter(user => user.is_celebrity);

                let items = [];
                this.users.forEach(user => {
                    items.push(this.transformUserData(user));
                });
                this.$set(this.tableData, 'items', items);

                this.$nextTick(() => this.initUpdateCelebrityAction());
            } catch (error) {}
        },
        showAddModal: function() {
            this.addeduser = {
                email: '',
                name: '',
                password: '',
                passwordConfirmation: '',
                role: null
            };

            this.isOpenAddModal = true;
        },
        showDeleteModal: function(data) {
            this.deletingId = data.id;
            this.isOpenDeleteModal = true;
        },
        showEditModal: function(data) {
            this.editedUser = {
                id: data.id,
                email: data.email,
                name: data.name,
                password: '',
                passwordConfirmation: '',
                role: data.role,
                roleName: data.roleName,
                referralId: data.referralId
            };

            this.isOpenEditModal = true;
        },
        transformUserData: function(user) {
            let actions = [
                {
                    method: 'showEditModal',
                    title: this.__('Edit')
                }
            ];

            return {
                values: {
                    id: user.id,
                    email: user.email,
                    name: user.name,
                    referralId: user.referral_id,
                    role: user.role.id,
                    roleName: user.role.display_name,
                    invitedUsersCount: user.invited_users.length,
                    totalAmountCollected: this.priceService.getFormattedPrice(
                        user.total_amount_collected
                    ),
                    isCelebrity: user.is_celebrity
                        ? '<input type="checkbox" class="js-is-celebrity" data-id="' +
                          user.id +
                          '" data-name="' +
                          user.name +
                          '" data-email="' +
                          user.email +
                          '" checked />'
                        : '<input type="checkbox" class="js-is-celebrity" data-id="' +
                          user.id +
                          '" data-name="' +
                          user.name +
                          '" data-email="' +
                          user.email +
                          '" />'
                },
                actions: actions
            };
        },
        sortDataTable: function(sortByColumn) {
            if (
                this.tableData.sortableColumns.includes(
                    sortByColumn.replace('-', '')
                )
            ) {
                this.getUsers(sortByColumn);
            }
        },
        updateUser: async function() {
            try {
                await this.userRepository.updateUserReferralId(
                    this.editedUser.id,
                    this.editedUser.name,
                    this.editedUser.email,
                    this.editedUser.referralId
                );

                await this.getUsers();

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('User was successfully updated.'),
                        this.__('Success.'),
                        'success'
                    )
                );

                this.isOpenEditModal = false;
            } catch (error) {
                this.errors = error.data.errors;
            }
        },
        updateUserIsCelebrity: async function(e) {
            const checkbox = e.target;
            const id = checkbox.getAttribute('data-id');
            const name = checkbox.getAttribute('data-name');
            const email = checkbox.getAttribute('data-email');
            let isCelebrity = 0;

            if (checkbox.checked) {
                isCelebrity = 1;
            }

            try {
                await this.userRepository.updateUserIsCelebrity(
                    id,
                    name,
                    email,
                    isCelebrity
                );

                await this.getUsers();

                store.state.alerts.push(
                    new MessageHandler(
                        this.__('User was successfully updated.'),
                        this.__('Success.'),
                        'success'
                    )
                );
            } catch (error) {
                this.errors = error.data.errors;
            }
        },
        initUpdateCelebrityAction: function() {
            const vue = this;

            this.$el
                .querySelectorAll('.js-is-celebrity')
                .forEach(function(checkbox) {
                    checkbox.removeEventListener(
                        'click',
                        vue.updateUserIsCelebrity
                    );
                    checkbox.addEventListener(
                        'click',
                        vue.updateUserIsCelebrity
                    );
                });
        }
    },
    mounted: function() {
        this.getUsers();
    }
};
</script>
